import { 
    getCenterTreeInfoTwo, 
    getTemplateInfoList, 
    getTemplateInfoById,
    newAddTemplateInfo, 
    newAddTemplateInfoTwo,
    editTemplateInfo,
    getTargetTableInfo
} from "@/api/dataCenter"
import { Message, MessageBox  } from 'element-ui'

const dataCenter = {
    state: {
        // 左侧tab
        leftIndex: 0,
        // 指标列表
        indicators: [], 
        // 选择的指标
        checkIndicators: [],
        // 模板列表
        template: [],
        // 模板详细指标
        templateInfo: {
            id: null,
            name: null,
            indicators: []
        },
        isAdd: false,
        // 模板所选表格数据
        tableData: [],
        // 表格图形数据
        targetTable: []
    },
    mutations: {
        SET_LEFT_TABLE: (state, index) => {
            state.leftIndex = index
        },
        SET_INDICATORS: (state, indicators) => {
            state.indicators = indicators
        }, 
        SET_TEMPLATE: (state, template) => {
            state.template = template
        },
        SET_TEMPLATE_INDICATORS: (state, checkIndicators) => {
            state.checkIndicators = checkIndicators
        },
        SET_CHECK_INDICATORS: (state, {row, type}) => {
            if (!row) return;
            const findIndex = state.checkIndicators.findIndex( item => item.id === row.id);
            if (type === 1) {
                // 添加
                if (findIndex === -1) {
                    state.checkIndicators.push(row);
                }
            } else if (type === 2) {
                // 删除
                state.checkIndicators.splice(findIndex, 1);
            }
        },
        SET_DEL_INFO: (state, row) => {
            let { id, name,  indicators } = state.templateInfo
            if (!row) return;
            const findIndex = indicators.findIndex( item => item.id === row.id);
            state.templateInfo.indicators.splice(findIndex, 1);
        },
        SET_TEMPLATE_INFO: (state, templateInfo) => {
            if (templateInfo) {
                state.templateInfo = templateInfo
            } else {
                state.templateInfo = {
                    id: null,
                    name: null,
                    indicators: []
                }
            }
        },
        SET_IS_ADD: (state, isAdd) => {
            state.isAdd = isAdd
        },
        SET_TABLE_DATA: (state, tableData) => {
            state.tableData = tableData
        },
        SET_TARGET_TABLE: (state, targetTable) => {
            state.targetTable = targetTable
        }
    },
    actions: {
        // 获取指标列表
        GetIndicators({ commit }, query = {}) {
            return new Promise((resolve, reject) => {
                getCenterTreeInfoTwo(query).then(res => {
                  commit('SET_INDICATORS', res.data);
                  resolve();
                }).catch(error => {
                  reject(error);
                })
            })
        },
        // 获取模板列表
        GetTemplate({ commit }) {
            return new Promise((resolve, reject) => {
                getTemplateInfoList().then(res => {
                  commit('SET_TEMPLATE', res.data);
                  resolve();
                }).catch(error => {
                  reject(error);
                })
            })
        },
        // 获取模板详细指标
        GetTemplateInfo({ commit, state }, info) {
            return new Promise((resolve, reject) => {
                getTemplateInfoById({ id: info.id }).then(res => {
                    let templateInfo = null
                    if (res.data) {
                        templateInfo = {
                            id: info.id,
                            name: info.name,
                            indicators: res.data
                        }
                    }
                    // 同步指标和模板内容
                    if (state.isAdd) {
                        commit('SET_TEMPLATE_INDICATORS', res.data);
                    }
                    commit('SET_TEMPLATE_INFO', templateInfo);
                    resolve();
                }).catch(error => {
                    commit('SET_TEMPLATE_INFO');
                    reject(error);
                })
            })
        },
        // 添加、编辑模板
        AddTemplate({ commit, state }, form) {
            return new Promise((resolve, reject) => {
                const axo = form.id ? 
                    editTemplateInfo(form) : 
                    newAddTemplateInfo(form)
                axo.then(res => {
                    if (res.code === 200) {
                        if (res.data === 2001) {
                            // 模板名称重复
                            MessageBox.confirm(`该${form.name}已存在是否要替换?`, '提示', {
                                showClose: false,
                                showCancelButton: true,
                                confirmButtonText: '是',
                                cancelButtonText: '否',
                                confirmButtonClass: 'data-center--confirm',
                                type: 'warning'
                              }).then(() => {
                                newAddTemplateInfoTwo(form)
                                .then(response => {
                                    Message({
                                        message: response.msg,
                                        type: 'success'
                                    })
                                    if (!form.id) {
                                        // 如果新增指标时名称重复
                                        if (state.isAdd) {
                                            commit("SET_IS_ADD", false)
                                        }
                                        commit("SET_TEMPLATE_INDICATORS", [])
                                    } else if(form.id === state.templateInfo.id){
                                        // 如果是修改名称时名称重复并且是当前选中的
                                        if (state.isAdd) {
                                            commit("SET_IS_ADD", false)
                                            commit("SET_TEMPLATE_INDICATORS", [])
                                            commit('SET_TEMPLATE_INFO');
                                        }
                                    }
                                    resolve(3);
                                }).catch(error => {
                                    reject(error);
                                })
                              }).catch(() => {
                                resolve(2);        
                              });
                        } else {
                            // 成功
                            Message({
                                message: res.msg,
                                type: 'success'
                            })
                            if (form.targetIds) {
                                // 如果是修改指标
                                if (state.isAdd) {
                                    commit("SET_IS_ADD", false)
                                }
                                if (state.leftIndex === 0 || state.isAdd) {
                                    commit("SET_TEMPLATE_INDICATORS", [])
                                }
                                resolve(form.id ? null : 1);
                            } else {
                                // 如果是修改名称
                                resolve(1);
                            }
                        }
                    } else {
                        Message({
                            message: res.msg,
                            type: 'warning'
                        }) 
                        resolve();
                    }
                }).catch(error => {
                  reject(error);
                })
            })
        },
        // 获取表格和图形数据
        GetTargetTable({ commit, state }) {
            return new Promise((resolve, reject) => {
                let arr = []
                if (state.leftIndex === 0) {
                    state.checkIndicators.forEach(item => {
                        arr.push(item.datasourceId)
                    });
                } else if (state.leftIndex === 1) {
                    state.tableData.forEach(item => {
                        arr.push(item.datasourceId)
                    });
                }
                if (arr.length === 0){
                    commit('SET_TARGET_TABLE', [])
                    resolve()
                } else {
                    getTargetTableInfo({datasourceIds: arr.join(",")})
                        .then(res => {
                            let result = []
                            if (res.code === 200 && res.data) {
                                result = res.data
                            }
                            commit('SET_TARGET_TABLE', result)
                            resolve(res)
                        }).catch( () => {
                            reject()
                        })
                }
            })
        }
    }
}

export default dataCenter